import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { RootState } from '../../../models/RootState';
import './CasinoIframeNew.scss';
import API from '../../../api';
import { DcGameUrl } from '../../../models/dc/DcGameUrl';
import { isMobile, isIOS } from 'react-device-detect';
import LoadingPage from '../../../pages/LoadingPage/LoadingPage';
import { BRAND_DOMAIN } from '../../../constants/Branding';
import { CASINO_PARTNER_ID_MAP } from '../../../constants/CasinoPartnerId';
import { getCurrencyTypeFromToken } from '../../../store';
import SVLS_API from '../../../svls-api';

type StoreProps = {
  gameUrl: string;
  loggedIn: boolean;
};

type RouteParams = {
  gamePath: string;
};

const CasinoIframeNew: React.FC<StoreProps> = (props) => {
  const [gameSrc, setGameSrc] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const { loggedIn } = props;

  const { gamePath } = useParams<RouteParams>();
  const history = useHistory();

  const getPartnerId = (provider: string) => {
    const cType = getCurrencyTypeFromToken();
    switch (cType) {
      case 0:
        return CASINO_PARTNER_ID_MAP[provider]
          ? CASINO_PARTNER_ID_MAP[provider]
          : 'hypexone';
      case 1:
        return 'hypex';
      case 2:
        return 'betex';
      default:
        return 'hypexone';
    }
  };

  const getGameUrl = async (
    gameId: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      setLoading(true);
      const claims = sessionStorage.getItem('jwt_token').split('.')[1];
      const userStatus = JSON.parse(window.atob(claims)).status;

      if (userStatus === 0 || userStatus === 3) {
        return history.push(`/home`);
      }

      // if (provider.toLocaleLowerCase() === 'ezugi') {
      let response;
      try {
        const reqBody = {
          gameId: gameId,
          providerName: provider,
          subProviderName: subProvider,
          platformId: isMobile ? 'mobile' : 'desktop',
        };
        response = await SVLS_API.post('/catalog/v2/live-casino/game-url', reqBody, {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        });
      } catch (e) {
        console.log(e);
      }

      if (response) {
        if (isMobile && isIOS) {
          setLoading(false);
          // window.location.href = response.data.url;
          setGameSrc(response.data);
        } else {
          setGameSrc(response.data);
          setLoading(false);
        }
      }
      // } else {
      //   const tokenResponse = await API.get('/dc/game/token', {
      //     headers: {
      //       Authorization: sessionStorage.getItem('jwt_token'),
      //     },
      //   });

      //   const dcToken = tokenResponse.data.message;

      //   const userId = JSON.parse(window.atob(claims)).userId;
      //   const response: AxiosResponse<DcGameUrl> = await API.post(
      //     '/dc/v1.1/game/url',
      //     {
      //       user: userId,
      //       token: dcToken,
      //       partner_id: getPartnerId(provider),
      //       platform: isMobile ? 'GPL_MOBILE' : 'GPL_DESKTOP',
      //       meta: {
      //         rating: 10,
      //         oddsType: 'decimal',
      //       },
      //       lobby_url: `https://www.${BRAND_DOMAIN}/dc`,
      //       lang: 'en',
      //       ip: '142.245.172.168',
      //       game_id: gameId,
      //       game_code: gameCode,
      //       deposit_url: `https://www.${BRAND_DOMAIN}`,
      //       country: 'IN',
      //     }
      //   );
      //   if (provider === 'Super Spade Games' && isMobile && isIOS) {
      //     setLoading(false);
      //     window.location.href = response.data.url;
      //   } else {
      //     setGameSrc(response.data.url);
      //     setLoading(false);
      //   }
      // }
    } else {
      history.push(`/`);
    }
  };

  useEffect(() => {
    const gameId = atob(gamePath.split('-')[gamePath.split('-').length - 4]);
    const gameCode = atob(gamePath.split('-')[gamePath.split('-').length - 3]);
    const provider = atob(gamePath.split('-')[gamePath.split('-').length - 2]);
    const subProvider = atob(
      gamePath.split('-')[gamePath.split('-').length - 1]
    );

    getGameUrl(gameId, gameCode, provider, subProvider);
  }, []);

  return (
    <div className="dc-iframe-ctn">
      <div id="loader" className="center"></div>
      {loading ? (
        <LoadingPage />
      ) : (
        <iframe
          src={gameSrc}
          title="DC game"
          allowFullScreen
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        ></iframe>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    gameUrl: state.common.dcGameUrl,
    loggedIn: state.auth.loggedIn,
  };
};

export default connect(mapStateToProps)(CasinoIframeNew);
